<mat-card class="row box-shadow">
    <mat-card-header>
        <mat-card-title class="col-12">
          <h3 class="col-12">Services clients</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
    <div class="col-12 user-info">

      <h5 class="col-12">
        <mat-icon aria-hidden="false">email</mat-icon> contact@clem.mobi
      </h5>
      <h5 class="col-12">
        <mat-icon aria-hidden="false">phone</mat-icon> +331 86 86 85 85
      </h5>

    </div>
  </mat-card-content>
  <mat-card-actions>
  </mat-card-actions>
</mat-card>
<mat-card class="row box-shadow">
  <mat-card-header>
    <mat-card-title class="col-12">
      <h3 class="col-12">Information de paiement</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="col-12 user-info">
      <div *ngIf="user.paymode == 'paydebit'">
        <h5 class="col-12">
           Prélèvement
        </h5>
      </div>
      <div *ngIf="user.paymode == 'prepaid'">
        <h5 class="col-12">
          <mat-icon aria-hidden="false">credit_card</mat-icon>  Prépaiement
        </h5>
        <h5 class="col-12">
          <mat-icon aria-hidden="false">money</mat-icon> Votre Solde : {{user.solde}} €
        </h5>
      </div>
      <div *ngIf="user.paymode == 'direct'">
        <h5 class="col-12">
           direct
        </h5>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div class="col-12">
      <div class="row justify-content-center">
        <button class="col-8" mat-stroked-button color="primary">Créditer</button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
